// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDLMc-lZcCNbylbfJHeplpcD0Xb5fJ7FrE",
  authDomain: "prints-by-jeroen.firebaseapp.com",
  projectId: "prints-by-jeroen",
  storageBucket: "prints-by-jeroen.appspot.com",
  messagingSenderId: "484951369743",
  appId: "1:484951369743:web:29e5e34378661da038db7a",
  measurementId: "G-LW3RMEY5X0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);


export { db, auth };